import { render, staticRenderFns } from "./Debts.vue?vue&type=template&id=348319c5"
import script from "./Debts.vue?vue&type=script&lang=js"
export * from "./Debts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports